export default {
	title: "",
	subtitle: "",
	path: "webhooks_subject_reproved",
	paragraph: "This following webhook notifies that a person or company registration has been rejected, as well as the reason for the reproval. This webhook is sent whenever the transaction limit for that person/company is reached, so its status automatically goes to 'reproved'. The API also sends it if the back-office rejects one or more of the provided documents.",
	request: {
		method: "POST",
		payloads: [
		 {
			title: "Notification",
			content: { 
			"notification": {
				"type": "subject_reproved",
				"subject_id": "someid",
				"reason": "Some reason for not being approved",
				"items": ["proof_of_address_missing"],
				"secret": "the value you received"
				}
			 }
		  }
		]
	},
	troubleshooting: {
    title: 'Other events that may trigger this webhook:',
    messages: [
			{
				description: 'The address proof document is not valid.',
				code: { notification: { type: 'subject_reproved', subject_id: 'UUID', 'items': [ 'proof_of_address_rejected' ], secret: 'some-secret' }},
				solution: ''
			},
			{
				description: 'The provided tax declaration is too old.',
				code: { notification: { type: 'subject_reproved', subject_id: 'UUID', 'items': [ 'old_tax_declaration' ], secret: 'some-secret' }},
				solution: ''
			},
			{
				description: 'Customer´s transactioned amount and provided tax declaration values mismatch.',
				code: { notification: { type: 'subject_reproved', subject_id: 'UUID', 'items': [ 'tax_declaration_insufficient' ], secret: 'some-secret' }},
				solution: ''
			}
		]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/WebhooksSubjectRejected.js